const MOI_VENDOR_SEARCH_DISTANCES = [2, 5, 10, 15, 25, 50] as const;

export default MOI_VENDOR_SEARCH_DISTANCES;
